import * as React from 'react';
import { Dialog, Button, DialogTitle, Typography, DialogActions } from '@mui/material';
import { withStyles } from '../../settings/styles';
import { WithTranslation, withTranslation } from 'react-i18next';

interface State {};

interface Props extends WithTranslation
{
    typeTitle?: string;
    itemTitle?: string;
    open: boolean;
    zIndex?: number;
    onClose: ()=>void;
    onDelete: ()=>void;
}

class DeleteDialog extends React.Component<Props, State>
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    render()
    {
        const { t } = this.props;
        return (<>
            <Dialog onClose={this.props.onClose} open={this.props.open}>
                <DialogTitle id="delete-dialog-title" style={{paddingBottom: "5px"}}>
                    <Typography style={{paddingBottom: "5px"}}>
                        {`${t('dialogs.delete.promptWithTitle')} ${this.props.typeTitle} ${this.props.itemTitle}?`}
                    </Typography>
                </DialogTitle>
                <DialogActions>
                    <Button onClick={this.props.onDelete} color="secondary">
                        {`${t('dialogs.delete.yes')}`}
                    </Button>
                    <Button onClick={this.props.onClose} color="primary">
                        {`${t('dialogs.delete.cancel')}`}
                    </Button>
                </DialogActions>
            </Dialog>
        </>);
    }
}

// ----------------- Export -----------------  //

export default withStyles(withTranslation()(DeleteDialog));

// ------------------------------------------  //